const initialState = {
    //job order info 
    loadingFFQueryDetail: false,
    FFQueryDetailError: "",
    FFQueryDetail: {},
    //job order List 
    loadingFFAirImpJobOrderList: false,
    FFAirImpJobOrderListError: "",
    FFAirImpJobOrderList: [],

    //currency List 
    loadingFFAirImpCurrencyList: false,
    FFAirImpCurrencyListError: "",
    FFAirImpCurrencyList: [],

    //final Quotation
    loadingFFAirImpFinalQuotationList: false,
    FFAirImpFinalQuotationListError: "",
    FFAirImpFinalQuotationList: [],

    //currency List 
    loadingFFAirImpAirportList: false,
    FFAirImpAirportListError: "",
    FFAirImpAirportList: [],


    //organisation list
    loadingFFAirImpOrganisationList: false,
    FFAirImpOrganisationList: [],
    FFAirImpOrganisationListError: '',

    //organisation shipper branch list
    loadingFFAirImpShipperBranchList: false,
    FFAirImpShipperBranchList: [],
    FFAirImpShipperBranchListError: '',

    //organisation consignee branch list
    loadingFFAirImpConsigneeBranchList: false,
    FFAirImpConsigneeBranchList: [],
    FFAirImpConsigneeBranchListError: '',

    //organisatoin shipper branch bank list
    loadingFFAirImpShipperBranchBankList: false,
    FFAirImpShipperBranchBankList: [],
    FFAirImpShipperBranchBankListError: '',

    //organisatoin consignee branch bank list
    loadingFFAirImpConsigneeBranchBankList: false,
    FFAirImpConsigneeBranchBankList: [],
    FFAirImpConsigneeBranchBankListError: '',

    //hawb details
    loadingFFAirImpHAWBDetail: false,
    FFAirImpHAWBDetail: [],
    FFAirImpHAWBDetailError: '',

    //direct mawb details
    loadingFFAirImpDirectMAWBDetail: false,
    FFAirImpDirectMAWBDetail: [],
    FFAirImpDirectMAWBDetailError: '',

    //mawb details
    loadingFFAirImpMAWBDetail: false,
    FFAirImpMAWBDetail: [],
    FFAirImpMAWBDetailError: '',

    //unused hawb list
    loadingFFAirImpUnusedHAWBList: false,
    FFAirImpUnusedHAWBList: [],
    FFAirImpUnusedHAWBListError: '',

    //unused hawb update list
    loadingFFAirImpUnusedHAWBUpdateList: false,
    FFAirImpUnusedHAWBUpdateList: [],
    FFAirImpUnusedHAWBUpdateListError: '',


    //ff-> air-> exp -> console shipment list
    loadingFFAirImpConsoleShipmentList: false,
    FFAirImpConsoleShipmentList: [],
    FFAirImpConsoleShipmentListError: '',
    FFAirImpConsoleShipmentListCurrentPage: 0,
    FFAirImpConsoleShipmentListTotalPage: 0,
    FFAirImpConsoleShipmentListTotalData: 0,
    // FFAirImpConsoleShipmentListCount: {},

    //ff-> air-> exp -> direct shipment list
    loadingFFAirImpDirectShipmentList: false,
    FFAirImpDirectShipmentList: [],
    FFAirImpDirectShipmentListError: '',
    FFAirImpDirectShipmentListCurrentPage: 0,
    FFAirImpDirectShipmentListTotalPage: 0,
    FFAirImpDirectShipmentListTotalData: 0,
    // FFAirImpDirectShipmentListCount: {},

    //ff-> air-> exp -> console Manifest list
    loadingFFAirImpConsoleManifestList: false,
    FFAirImpConsoleManifestList: [],
    FFAirImpConsoleManifestListError: '',
    FFAirImpConsoleManifestListCurrentPage: 0,
    FFAirImpConsoleManifestListTotalPage: 0,
    FFAirImpConsoleManifestListTotalData: 0,
    // FFAirImpConsoleManifestListCount: {},

    //mawb => total freight calculation
    loadingFFAirImpTotalFreight: false,
    FFAirImpTotalFreight: {},
    FFAirImpTotalFreightError: '',

}

const FFAirImpReducer = (state = initialState, action) => {
    switch (action.type) {

        //query info List//
        case 'FIND_FF_QUERY_INFO_REQUEST':
            return {
                ...state,
                loadingFFQueryDetail: true,
                FFQueryDetail: {},
                FFQueryDetailError: '',
            };
        case 'FIND_FF_QUERY_INFO_SUCCESS':
            return {
                ...state,
                loadingFFQueryDetail: false,
                FFQueryDetail: action.payload,
            };
        case 'FIND_FF_QUERY_INFO_FAILURE':
            return {
                ...state,
                loadingFFQueryDetail: false,
                FFQueryDetailError: action.payload,
            };
        //query info List//

        //job order List//
        case 'FIND_FF_AIR_IMP_JOBORDER_REQUEST':
            return {
                ...state,
                loadingFFAirImpJobOrderList: true,
                FFAirImpJobOrderList: [],
                FFAirImpJobOrderListError: '',
            };
        case 'FIND_FF_AIR_IMP_JOBORDER_SUCCESS':
            return {
                ...state,
                loadingFFAirImpJobOrderList: false,
                FFAirImpJobOrderList: action.payload,
            };
        case 'FIND_FF_AIR_IMP_JOBORDER_FAILURE':
            return {
                ...state,
                loadingFFAirImpJobOrderList: false,
                FFAirImpJobOrderListError: action.payload,
            };
        //job order List//

        //currency List//
        case 'FIND_FF_AIR_IMP_CURRENCY_REQUEST':
            return {
                ...state,
                loadingFFAirImpCurrencyList: true,
                FFAirImpCurrencyList: [],
                FFAirImpCurrencyListError: '',
            };
        case 'FIND_FF_AIR_IMP_CURRENCY_SUCCESS':
            return {
                ...state,
                loadingFFAirImpCurrencyList: false,
                FFAirImpCurrencyList: action.payload,
            };
        case 'FIND_FF_AIR_IMP_CURRENCY_FAILURE':
            return {
                ...state,
                loadingFFAirImpCurrencyList: false,
                FFAirImpCurrencyListError: action.payload,
            };
        //currency List//

        //final Quotation List//
        case 'FIND_FF_AIR_IMP_FINAL_QUOTATION_REQUEST':
            return {
                ...state,
                loadingFFAirImpFinalQuotationList: true,
                FFAirImpFinalQuotationList: [],
                FFAirImpFinalQuotationListError: '',
            };
        case 'FIND_FF_AIR_IMP_FINAL_QUOTATION_SUCCESS':
            return {
                ...state,
                loadingFFAirImpFinalQuotationList: false,
                FFAirImpFinalQuotationList: action.payload,
            };
        case 'FIND_FF_AIR_IMP_FINAL_QUOTATION_FAILURE':
            return {
                ...state,
                loadingFFAirImpFinalQuotationList: false,
                FFAirImpFinalQuotationListError: action.payload,
            };
        //final Quotation List//

        //airport List//
        case 'FIND_FF_AIR_IMP_AIRPORT_REQUEST':
            return {
                ...state,
                loadingFFAirImpAirportList: true,
                FFAirImpAirportList: [],
                FFAirImpAirportListError: '',
            };
        case 'FIND_FF_AIR_IMP_AIRPORT_SUCCESS':
            return {
                ...state,
                loadingFFAirImpAirportList: false,
                FFAirImpAirportList: action.payload,
            };
        case 'FIND_FF_AIR_IMP_AIRPORT_FAILURE':
            return {
                ...state,
                loadingFFAirImpAirportList: false,
                FFAirImpAirportListError: action.payload,
            };
        //airport List//

        //hawb detail//
        case 'FIND_FF_AIR_IMP_HAWB_DETAIL_REQUEST':
            return {
                ...state,
                loadingFFAirImpHAWBDetail: true,
                FFAirImpHAWBDetail: [],
                FFAirImpHAWBDetailError: '',
            };
        case 'FIND_FF_AIR_IMP_HAWB_DETAIL_SUCCESS':
            return {
                ...state,
                loadingFFAirImpHAWBDetail: false,
                FFAirImpHAWBDetail: action.payload,
            };
        case 'FIND_FF_AIR_IMP_HAWB_DETAIL_FAILURE':
            return {
                ...state,
                loadingFFAirImpHAWBDetail: false,
                FFAirImpHAWBDetailError: action.payload,
            };
        //hawb detail//

        //direct mawb detail//
        case 'FIND_FF_AIR_IMP_DIRECT_MAWB_DETAIL_REQUEST':
            return {
                ...state,
                loadingFFAirImpDirectMAWBDetail: true,
                FFAirImpDirectMAWBDetail: [],
                FFAirImpDirectMAWBDetailError: '',
            };
        case 'FIND_FF_AIR_IMP_DIRECT_MAWB_DETAIL_SUCCESS':
            return {
                ...state,
                loadingFFAirImpDirectMAWBDetail: false,
                FFAirImpDirectMAWBDetail: action.payload,
            };
        case 'FIND_FF_AIR_IMP_DIRECT_MAWB_DETAIL_FAILURE':
            return {
                ...state,
                loadingFFAirImpDirectMAWBDetail: false,
                FFAirImpDirectMAWBDetailError: action.payload,
            };
        //direct mawb detail//

        //mawb detail//
        case 'FIND_FF_AIR_IMP_MAWB_DETAIL_REQUEST':
            return {
                ...state,
                loadingFFAirImpMAWBDetail: true,
                FFAirImpMAWBDetail: [],
                FFAirImpMAWBDetailError: '',
            };
        case 'FIND_FF_AIR_IMP_MAWB_DETAIL_SUCCESS':
            return {
                ...state,
                loadingFFAirImpMAWBDetail: false,
                FFAirImpMAWBDetail: action.payload,
            };
        case 'FIND_FF_AIR_IMP_MAWB_DETAIL_FAILURE':
            return {
                ...state,
                loadingFFAirImpMAWBDetail: false,
                FFAirImpMAWBDetailError: action.payload,
            };
        //mawb detail//

        //organisation List//
        case 'FIND_FF_AIR_IMP_ORGANISATION_REQUEST':
            return {
                ...state,
                loadingFFAirImpOrganisationList: true,
                FFAirImpOrganisationList: [],
                FFAirImpOrganisationListError: '',
            };
        case 'FIND_FF_AIR_IMP_ORGANISATION_SUCCESS':
            return {
                ...state,
                loadingFFAirImpOrganisationList: false,
                FFAirImpOrganisationList: action.payload,
            };
        case 'FIND_FF_AIR_IMP_ORGANISATION_FAILURE':
            return {
                ...state,
                loadingFFAirImpOrganisationList: false,
                FFAirImpOrganisationListError: action.payload,
            };
        //organisation List//

        //organisation shipper branch List//
        case 'FIND_FF_AIR_IMP_SHIPPER_BRANCH_REQUEST':
            return {
                ...state,
                loadingFFAirImpShipperBranchList: true,
                FFAirImpShipperBranchList: [],
                FFAirImpShipperBranchListError: '',
            };
        case 'FIND_FF_AIR_IMP_SHIPPER_BRANCH_SUCCESS':
            return {
                ...state,
                loadingFFAirImpShipperBranchList: false,
                FFAirImpShipperBranchList: action.payload,
            };
        case 'FIND_FF_AIR_IMP_SHIPPER_BRANCH_FAILURE':
            return {
                ...state,
                loadingFFAirImpShipperBranchList: false,
                FFAirImpShipperBranchListError: action.payload,
            };
        //organisation shipper branch List//

        //organisation consignee branch List//
        case 'FIND_FF_AIR_IMP_CONSIGNEE_BRANCH_REQUEST':
            return {
                ...state,
                loadingFFAirImpConsigneeBranchList: true,
                FFAirImpConsigneeBranchList: [],
                FFAirImpConsigneeBranchListError: '',
            };
        case 'FIND_FF_AIR_IMP_CONSIGNEE_BRANCH_SUCCESS':
            return {
                ...state,
                loadingFFAirImpConsigneeBranchList: false,
                FFAirImpConsigneeBranchList: action.payload,
            };
        case 'FIND_FF_AIR_IMP_CONSIGNEE_BRANCH_FAILURE':
            return {
                ...state,
                loadingFFAirImpConsigneeBranchList: false,
                FFAirImpConsigneeBranchListError: action.payload,
            };
        //organisation consignee branch List//

        //organisation shipper branch bank List//
        case 'FIND_FF_AIR_IMP_SHIPPER_BRANCH_BANK_REQUEST':
            return {
                ...state,
                loadingFFAirImpShipperBranchBankList: true,
                FFAirImpShipperBranchBankList: [],
                FFAirImpShipperBranchBankListError: '',
            };
        case 'FIND_FF_AIR_IMP_SHIPPER_BRANCH_BANK_SUCCESS':
            return {
                ...state,
                loadingFFAirImpShipperBranchBankList: false,
                FFAirImpShipperBranchBankList: action.payload,
            };
        case 'FIND_FF_AIR_IMP_SHIPPER_BRANCH_BANK_FAILURE':
            return {
                ...state,
                loadingFFAirImpShipperBranchBankList: false,
                FFAirImpShipperBranchBankListError: action.payload,
            };
        //organisation shipper branch bank List//

        //organisation consignee branch bank List//
        case 'FIND_FF_AIR_IMP_CONSIGNEE_BRANCH_BANK_REQUEST':
            return {
                ...state,
                loadingFFAirImpConsigneeBranchBankList: true,
                FFAirImpConsigneeBranchBankList: [],
                FFAirImpConsigneeBranchBankListError: '',
            };
        case 'FIND_FF_AIR_IMP_CONSIGNEE_BRANCH_BANK_SUCCESS':
            return {
                ...state,
                loadingFFAirImpConsigneeBranchBankList: false,
                FFAirImpConsigneeBranchBankList: action.payload,
            };
        case 'FIND_FF_AIR_IMP_CONSIGNEE_BRANCH_BANK_FAILURE':
            return {
                ...state,
                loadingFFAirImpConsigneeBranchBankList: false,
                FFAirImpConsigneeBranchBankListError: action.payload,
            };
        //organisation consignee branch bank List//

        //mawb-> unused hawb list//
        case 'FIND_FF_AIR_IMP_UNUSED_HAWB_REQUEST':
            return {
                ...state,
                loadingFFAirImpUnusedHAWBList: true,
                FFAirImpUnusedHAWBList: [],
                FFAirImpUnusedHAWBListError: '',
            };
        case 'FIND_FF_AIR_IMP_UNUSED_HAWB_SUCCESS':
            return {
                ...state,
                loadingFFAirImpUnusedHAWBList: false,
                FFAirImpUnusedHAWBList: action.payload,
            };
        case 'FIND_FF_AIR_IMP_UNUSED_HAWB_FAILURE':
            return {
                ...state,
                loadingFFAirImpUnusedHAWBList: false,
                FFAirImpUnusedHAWBListError: action.payload,
            };
        //mawb-> unused hawb list//

        //mawb-> unused hawb update list//
        case 'FIND_FF_AIR_IMP_UNUSED_HAWB_UPDATE_REQUEST':
            return {
                ...state,
                loadingFFAirImpUnusedHAWBUpdateList: true,
                FFAirImpUnusedHAWBUpdateList: [],
                FFAirImpUnusedHAWBUpdateListError: '',
            };
        case 'FIND_FF_AIR_IMP_UNUSED_HAWB_UPDATE_SUCCESS':
            return {
                ...state,
                loadingFFAirImpUnusedHAWBUpdateList: false,
                FFAirImpUnusedHAWBUpdateList: action.payload,
            };
        case 'FIND_FF_AIR_IMP_UNUSED_HAWB_UPDATE_FAILURE':
            return {
                ...state,
                loadingFFAirImpUnusedHAWBUpdateList: false,
                FFAirImpUnusedHAWBUpdateListError: action.payload,
            };
        //mawb-> unused hawb update list//

        //mawb-> unused mawb in console manifest add form//
        case 'FIND_FF_AIR_IMP_CONSOLE_MANIFEST_MAWB_ADD_LIST_REQUEST':
            return {
                ...state,
                loadingFFAirImpUnusedConsoleManifestMAWBAddList: true,
                FFAirImpUnusedConsoleManifestMAWBAddList: [],
                FFAirImpUnusedConsoleManifestMAWBAddListError: '',
            };
        case 'FIND_FF_AIR_IMP_CONSOLE_MANIFEST_MAWB_ADD_LIST_SUCCESS':
            return {
                ...state,
                loadingFFAirImpUnusedConsoleManifestMAWBAddList: false,
                FFAirImpUnusedConsoleManifestMAWBAddList: action.payload,
            };
        case 'FIND_FF_AIR_IMP_CONSOLE_MANIFEST_MAWB_ADD_LIST_FAILURE':
            return {
                ...state,
                loadingFFAirImpUnusedConsoleManifestMAWBAddList: false,
                FFAirImpUnusedConsoleManifestMAWBAddListError: action.payload,
            };
        //mawb-> unused mawb in console manifest add form//

        //mawb-> calculate total freight//
        case 'FIND_CALCULATE_TOTAL_FREIGHT_REQUEST':
            return {
                ...state,
                loadingFFAirImpTotalFreight: true,
                FFAirImpTotalFreight: {},
                FFAirImpTotalFreightError: '',
            };
        case 'FIND_CALCULATE_TOTAL_FREIGHT_SUCCESS':
            return {
                ...state,
                loadingFFAirImpTotalFreight: false,
                FFAirImpTotalFreight: action.payload,
            };
        case 'FIND_CALCULATE_TOTAL_FREIGHT_FAILURE':
            return {
                ...state,
                loadingFFAirImpTotalFreight: false,
                FFAirImpTotalFreightError: action.payload,
            };
        //mawb-> calculate total freight//

        //ff -> air -> exp -> console shipment list//
        case 'FIND_FF_AIR_IMP_CONSOLE_SHIPMENT_LIST_REQUEST':
            return {
                ...state,
                loadingFFAirImpConsoleShipmentList: true,
                FFAirImpConsoleShipmentList: [],
                FFAirImpConsoleShipmentListError: '',
                FFAirImpConsoleShipmentListCurrentPage: 0,
                FFAirImpConsoleShipmentListTotalPage: 0,
                FFAirImpConsoleShipmentListTotalData: 0,
                // FFAirImpConsoleShipmentListCount: {},
            };
        case 'FIND_FF_AIR_IMP_CONSOLE_SHIPMENT_LIST_SUCCESS':
            return {
                ...state,
                loadingFFAirImpConsoleShipmentList: false,
                FFAirImpConsoleShipmentList: action.payload.data,
                FFAirImpConsoleShipmentListCurrentPage: action.payload.pagination ? action.payload.pagination.currentPage : 1,
                FFAirImpConsoleShipmentListTotalPage: action.payload.pagination ? action.payload.pagination.totalPages : 0,
                FFAirImpConsoleShipmentListTotalData: action.payload.pagination ? action.payload.pagination.totalRecords : 0,
                // FFAirImpConsoleShipmentListCount: {},
            };
        case 'FIND_FF_AIR_IMP_CONSOLE_SHIPMENT_LIST_FAILURE':
            return {
                ...state,
                loadingFFAirImpConsoleShipmentList: true,
                FFAirImpConsoleShipmentListError: '',
                FFAirImpConsoleShipmentListCurrentPage: 1,
                FFAirImpConsoleShipmentListTotalPage: 0,
                FFAirImpConsoleShipmentListTotalData: 0,
                // FFAirImpConsoleShipmentListCount: {},
            };
        //ff -> air -> exp -> console shipment list//

        //ff -> air -> exp -> direct shipment list//
        case 'FIND_FF_AIR_IMP_DIRECT_SHIPMENT_LIST_REQUEST':
            return {
                ...state,
                loadingFFAirImpDirectShipmentList: true,
                FFAirImpDirectShipmentList: [],
                FFAirImpDirectShipmentListError: '',
                FFAirImpDirectShipmentListCurrentPage: 0,
                FFAirImpDirectShipmentListTotalPage: 0,
                FFAirImpDirectShipmentListTotalData: 0,
                // FFAirImpDirectShipmentListCount: {},
            };
        case 'FIND_FF_AIR_IMP_DIRECT_SHIPMENT_LIST_SUCCESS':
            return {
                ...state,
                loadingFFAirImpDirectShipmentList: false,
                FFAirImpDirectShipmentList: action.payload.data,
                FFAirImpDirectShipmentListCurrentPage: action.payload.pagination ? action.payload.pagination.currentPage : 1,
                FFAirImpDirectShipmentListTotalPage: action.payload.pagination ? action.payload.pagination.totalPages : 0,
                FFAirImpDirectShipmentListTotalData: action.payload.pagination ? action.payload.pagination.totalRecords : 0,
                // FFAirImpDirectShipmentListCount: {},
            };
        case 'FIND_FF_AIR_IMP_DIRECT_SHIPMENT_LIST_FAILURE':
            return {
                ...state,
                loadingFFAirImpDirectShipmentList: true,
                FFAirImpDirectShipmentListError: '',
                FFAirImpDirectShipmentListCurrentPage: 1,
                FFAirImpDirectShipmentListTotalPage: 0,
                FFAirImpDirectShipmentListTotalData: 0,
                // FFAirImpDirectShipmentListCount: {},
            };
        //ff -> air -> exp -> direct shipment list//

        //ff -> air -> exp -> console manifest list//
        case 'FIND_FF_AIR_IMP_CONSOLE_MANIFEST_LIST_REQUEST':
            return {
                ...state,
                loadingFFAirImpConsoleManifestList: true,
                FFAirImpConsoleManifestList: [],
                FFAirImpConsoleManifestListError: '',
                FFAirImpConsoleManifestListCurrentPage: 0,
                FFAirImpConsoleManifestListTotalPage: 0,
                FFAirImpConsoleManifestListTotalData: 0,
                // FFAirImpConsoleManifestListCount: {},
            };
        case 'FIND_FF_AIR_IMP_CONSOLE_MANIFEST_LIST_SUCCESS':
            return {
                ...state,
                loadingFFAirImpConsoleManifestList: false,
                FFAirImpConsoleManifestList: action.payload.data,
                FFAirImpConsoleManifestListCurrentPage: action.payload.pagination ? action.payload.pagination.currentPage : 1,
                FFAirImpConsoleManifestListTotalPage: action.payload.pagination ? action.payload.pagination.totalPages : 0,
                FFAirImpConsoleManifestListTotalData: action.payload.pagination ? action.payload.pagination.totalRecords : 0,
                // FFAirImpConsoleManifestListCount: {},
            };
        case 'FIND_FF_AIR_IMP_CONSOLE_MANIFEST_LIST_FAILURE':
            return {
                ...state,
                loadingFFAirImpConsoleManifestList: true,
                FFAirImpConsoleManifestListError: '',
                FFAirImpConsoleManifestListCurrentPage: 1,
                FFAirImpConsoleManifestListTotalPage: 0,
                FFAirImpConsoleManifestListTotalData: 0,
                // FFAirImpConsoleManifestListCount: {},
            };
        //ff -> air -> exp -> console manifest list//

        default:
            return state;
    }
}

export default FFAirImpReducer;